import { CopilotKitProvider } from "@copilotkit/react-core/v2";
import { ContextProvider } from "./provider";
import type { ChatState } from "./state";

export const RedeemCopilotContext = ({
	runtimeUrl,
	headers,
	enableAnalytics = false,
	initialChatState,
	instructions,
	children,
}: {
	runtimeUrl: string;
	headers?: Record<string, string>;
	enableAnalytics?: boolean;
	initialChatState?: Partial<ChatState>;
	instructions?: string;
	children?: React.ReactNode;
}) => {
	const hasAuth = Boolean(headers?.Authorization ?? headers?.authorization);
	return (
		<CopilotKitProvider
			key={hasAuth ? "auth" : "no-auth"}
			runtimeUrl={runtimeUrl}
			headers={headers}
			showDevConsole={false}
			useSingleEndpoint
		>
			<ContextProvider
				enableAnalytics={enableAnalytics}
				initialChatState={initialChatState}
				instructions={instructions}
			>
				{children}
			</ContextProvider>
		</CopilotKitProvider>
	);
};
